import { useState } from 'react'
import { PlannedTab } from './planning/planned-tab'
import { RecurringTab } from './planning/recurring-tab'

type Tab = 'planned' | 'recurring'

export function Planning() {
  const [tab, setTab] = useState<Tab>('planned')

  return (
    <div className="content">
      <nav
        style={{
          display: 'flex',
          gap: 0,
          borderBottom: '1px solid var(--border-default)',
          marginBottom: 16,
        }}
      >
        <TabBtn active={tab === 'planned'} onClick={() => setTab('planned')}>
          Планові операції
        </TabBtn>
        <TabBtn active={tab === 'recurring'} onClick={() => setTab('recurring')}>
          Регулярні шаблони
        </TabBtn>
      </nav>

      {tab === 'planned' ? <PlannedTab /> : <RecurringTab />}
    </div>
  )
}

function TabBtn({
  active,
  onClick,
  children,
}: {
  active: boolean
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        padding: '8px 16px',
        fontSize: 14,
        background: 'none',
        border: 'none',
        borderBottom: `2px solid ${active ? 'var(--accent)' : 'transparent'}`,
        color: active ? 'var(--accent)' : 'var(--fg-2)',
        cursor: 'pointer',
        fontWeight: active ? 600 : 400,
        marginBottom: -1,
        transition: 'color 0.15s, border-color 0.15s',
      }}
    >
      {children}
    </button>
  )
}
